import React, { useEffect, useState, Fragment } from 'react';
import queryString from 'query-string';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withFirebaseConsumer } from 'components/common/Firebase';
// import PropTypes from 'prop-types' // TODO!!!: proptypes
import { ResetPassword } from './ResetPassword';
import { ConfirmEmailVerification } from './ConfirmEmailVerification';
import { RecoverEmail } from './RecoverEmail';

const HandleAuthBase = props => {
  const initialState = {
    fetching: false,
    oobcode: null,
    mode: null,
    loaded: false,

    action: null /* change_email_address (send link), 
                        verify_email_address, 
                        request_reset_password, 
                        reset_password,
                        sign_up,
                        sign_in,
                        sign_out */,
    actionHandler: null /* reset_password,
                                recover_email,
                                verify_email */
  };
  const [state, setState] = useState(initialState);

  console.log(props);

  useEffect(() => {
    setState({ fetching: true });
    const values = queryString.parse(props.location.search);
    setState({
      fetching: false,
      oobCode: values.oobCode,
      mode: values.mode,
      loaded: true
    });
  }, []);

  if (state.loaded) {
    switch (state.mode) {
      case 'resetPassword':
        return <ResetPassword oobCode={state.oobCode} />;
        break;
      case 'recoverEmail':
        return <RecoverEmail oobCode={state.oobCode} />;
        break;
      case 'verifyEmail':
        return <ConfirmEmailVerification oobCode={state.oobCode} />;
        break;
      default:
      // Error: invalid mode.
    }
  } else {
    return <Fragment>Loading</Fragment>;
  }
};

export const HandleAuth = compose(
  withFirebaseConsumer,
  withRouter
)(HandleAuthBase);
